import { PlayerContentType } from '@/scenarios/legacy-player/components/feature-player/types/content';
import { PlaybackRateRange, VideoTrack } from '@/scenarios/legacy-player/types/instance';

import { SubtitlesRatio } from '../Subtitles/Subtitles.types';
import { Option } from '../OptionList';

export const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const;
export type PlaybackRate = (typeof PLAYBACK_RATES)[number];

export interface SettingsProps {
    isSubtitlesSizeForced?: boolean;
    playerContentType?: PlayerContentType | null;
    setSubtitlesRatio?: (ratio: SubtitlesRatio) => void;
    subtitlesRatio?: SubtitlesRatio;
    videoTracks: ReadonlyArray<VideoTrack>;
    currentVideoTrack?: VideoTrack;
    currentRate?: number;
    playbackRateRange?: PlaybackRateRange;
    handleQualitySelect: (qualityOption: Option<string>) => void;
    handleRateSelect: (rateOption: Option<PlaybackRate>) => void;
}

export enum SettingsScreen {
    LIST = 'list',
    QUALITY = 'quality',
    RATE = 'rate',
    SUBTITLES_SIZE = 'subtitlesSize',
}
